const React = window.React;
export function logOnToZephr({ emailVal, passwordVal, retry = false }) {

    return new Promise((resolve, reject) => {
        const payload = {
            identifiers: {
                email_address: emailVal,
            },
            validators: {
                password: passwordVal,
            },
        };

        if (retry) {
            payload.validators.password = "";
            payload.validators.legacy_password = passwordVal;
        }

        fetch("/blaize/login", {
            body: JSON.stringify(payload),
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
            },
        })
            .then( (res) => {

                return res.json();
            })
            .then( (data) => {
                
                if ( data.status && ( data.status !== 200 ) ) {
                    return reject({
                        data,
                        errorMessage: errorMessagesForUser[data.status],
                    });
                } else {
                    analyticEvents();
                    return resolve(data);
                }
            
            })
            .catch((err) => {
                console.error("Blaize Login Error", err);
                return reject(err);
            });
    });
}

export const requestForgotPassword = async ( email ) => {
    return fetch("/blaize/users/reset", {
        "headers": {
            "Accept": "application/json",
            "Content-Type": "application/json",
        },
        "body": JSON.stringify({
            "identifiers":{
                "email_address": email
            }
        }),
        "method": "POST",
        "mode": "cors",
        "credentials": "include"
    });
}

export const requestMagicLink = async (email) => {
    return fetch("/blaize/token-exchange", {
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            identifiers: {
                email_address: email
            },
            delivery: {
                method: "email",
                destination: email,
                action: "login",
                redirect: window.location.href,
            },
        }),
        method: "POST",
        mode: "cors",
        credentials: "include",
    });
};

export const errorMessagesForUser = {
    400: "Invalid email or password",
    401: "Invalid email or password",
    403: "Invalid email or password",
    404: "Invalid email or password",
    500: "There was an error logging in. Please try again later.",
};

function analyticEvents() {
    if (typeof PARSELY !== "undefined" && PARSELY?.conversions?.trackLinkClick) {
        PARSELY.conversions.trackLinkClick("SiteLogin");
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: "Zephr",
        zeventCategory: "Login",
        zeventLabel: "Login Success",
    });
}

export const useAnimIn = (ref, {stagger = false} = {}) => {
   
    React.useEffect(() => {

        if (typeof anime === "function" && ref?.current) {

            const animeOptions = {
                targets: ref.current,
                opacity: [0, 1],
                translateY: [10, 0],
                duration: 500,
                easing: "easeOutSine",
            }

            if (stagger) {
                animeOptions['targets'] = ref.current.children;
                animeOptions['delay'] = anime.stagger(100);
            }

            anime(animeOptions);
        }
        
    });

}